import { FileBarChart } from 'lucide-react';
import { ReportGeneratedEvent as ReportGeneratedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: ReportGeneratedEventType;
}

export default function ReportGeneratedEvent({ event }: Props) {
  return (
    <EventShell
      color="indigo"
      icon={<FileBarChart className="w-3.5 h-3.5" />}
      title="Report Generated"
      timestamp={event.created_at}
    >
      {event.payload.report_name && <p>{event.payload.report_name}</p>}
      {event.payload.destination && <p>Sent to: {event.payload.destination}</p>}
    </EventShell>
  );
}
